import { useEffect, useState } from "react";
import { errorReq } from "sources/home";

export default function HomeError() {
    const [requestId, setRequestId] = useState("");
    useEffect(() => {
        errorReq().then((res) => {
            if (res) {
                setRequestId(res.requestId);
            }
        });
    }, []);

    return requestId;
}
